import React from "react";

function QuiSommeNous(props) {
  return (
    <div>
      <h1>Qui somme nous?</h1>
      <p>
        <strong>Nous:</strong>
        <br />
        LudoBlue est une association de loi 1901, à but non lucratif, située
        en Haute-Loire. Elle a reçu l’agrément de la jeunesse et de l’éducation
        populaire en 2011. Ses 3 grands objectifs sont de : rendre le jeu
        accessible à tous, promouvoir le jeu comme reflet des cultures et
        participer au tissage du lien social en créant des espaces de rencontres
        autour du Jeu.
        <br />
        En 2006, la ludothèque itinérante LudoBlue a été créée. Grâce à un
        stock de jeux et jouets diversifiés, elle propose des « temps de jeux »
        éphémères dans des lieux mis à disposition, et du prêt de jeux et jouets
        (au Pertuis). A travers ses actions autour du Jeu, LudoBlue défend
        des valeurs de plaisir, de partage et de liberté. Elle accueille tout
        public, toutes générations confondues. L’association LudoBlue
        fonctionne grâce au bénévolat, au salariat, aux dons et aux subventions.
      </p>

  

      <p>
        <strong>Comment:</strong>
        <br /> C’est le plus beau des camions, rempli de merveilleux jeux et
        jouets, qui vient jusqu’à vous, pour créer et installer un espace dédié
        au jeu de façon éphémère.
        <br />
        Et après ! Une fois le camion déchargé !<br />
        Un ou plusieurs membres de l’association (qualifié en animation) sera là
        pour accompagner ce « temps de jeux ».
      </p>

      <p>
        <strong>Pourqui: </strong>
        <br /> Lorsque vous souhaitez un « temps de jeux » ou emprunter, il
        suffit de prendre contact avec les animateurs de la ludothèque
        itinérante LudoBlue. Un devis vous sera proposé. Une fois celui-ci
        signé et retourné au bureau situés au Pertuis : la(les) date(s) du «
        Temps de jeux » est (sont) fixée(s) dans le calendrier. La ludothèque
        itinérante vient alors une première fois à vous pour visualiser l’espace
        qui sera dédié au Jeu, et fixer les modalités de fonctionnement à
        travers une convention établie entre les deux parties.
      </p>

      
    </div>
  );
}

export default QuiSommeNous;
